import { formatCourt } from '@mosaik/core';

export { formatCourt };

export function euros(n: number): string {
  return `${n.toLocaleString('fr-FR', { maximumFractionDigits: 0 })} €`;
}

export function heureCourte(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export function dateHeure(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

/** Classe CSS du bandeau coloré d'une gravité. */
export function tonGravite(gravite: number): string {
  return gravite === 3 ? 'brick' : gravite === 2 ? 'ocre' : gravite === 0 ? 'pine' : '';
}

/** Nom des fournisseurs d'une commande, avec le compte des autres. */
export function libelleFournisseurs(fournisseurs: string[]): string {
  const [premier, ...reste] = fournisseurs;
  if (!premier) return '';
  return reste.length ? `${premier} +${reste.length}` : premier;
}
